import { render, staticRenderFns } from "./mgCarfee.vue?vue&type=template&id=46342749&"
import script from "./mgCarfee.vue?vue&type=script&lang=js&"
export * from "./mgCarfee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports